import { render, staticRenderFns } from "./AfterInfo.vue?vue&type=template&id=763ca902&scoped=true&"
import script from "./AfterInfo.vue?vue&type=script&lang=js&"
export * from "./AfterInfo.vue?vue&type=script&lang=js&"
import style0 from "./AfterInfo.vue?vue&type=style&index=0&id=763ca902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ca902",
  null
  
)

export default component.exports